import { Link as ILink } from "@customTypes/index";
import { Button, Col, Row } from "antd";

import { Link } from "react-router-dom";

interface CallToActionProps {
  className?: string;
  title?: string;
  description?: string | null;
  link: ILink;
}

const defaultProps: CallToActionProps = {
  className: "",
  title: "",
  description: null,
  link: {
    url: "/",
    name: "Click Me!",
    target: "_self",
  },
};

const CallToAction = ({ className, title, description, link }: CallToActionProps) => {
  return (
    <Row className={`covr-cta-general ${className}`} justify="space-between" align="middle">
      <Col>
        <h3>{title}</h3>
        <p>{description}</p>
        <Button>
          <Link target={link.target} to={link.url}>
            {link.name}
          </Link>
        </Button>
      </Col>
    </Row>
  );
};

CallToAction.defaultProps = defaultProps;

export default CallToAction;
